/* import __COLOCATED_TEMPLATE__ from './campaign-modal-trigger.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type CardlessConversionModalService from 'embercom/services/cardless-conversion-modal-service';
import type CompellingOfferClaimModalService from 'embercom/services/compelling-offer-claim-modal-service';

interface Signature {
  Args: {};
}

export default class CampaignModalTrigger extends Component<Signature> {
  @service declare cardlessConversionModalService: CardlessConversionModalService;
  @service declare compellingOfferClaimModalService: CompellingOfferClaimModalService;

  @action
  tryOpenModal(): void {
    // Priority 1: cardless conversion modal (query-param driven, re-checked on route change)
    if (this.cardlessConversionModalService.shouldOpenFromQueryParam) {
      this.cardlessConversionModalService.tryOpenFromQueryParam();
      return;
    }

    // Priority 2: compelling offer claim modal (page-load driven, idempotent via hasOpened guard)
    this.compellingOfferClaimModalService.maybeOpen();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CampaignModalTrigger: typeof CampaignModalTrigger;
    'campaign-modal-trigger': typeof CampaignModalTrigger;
  }
}
